"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MappingClient = void 0;
const tslib_1 = require("tslib");
const business_constants_1 = require("@contentsquare/business-constants");
const global_object_1 = tslib_1.__importDefault(require("../global-object"));
const crud_client_1 = require("./crud.client");
class MappingClient extends crud_client_1.CrudClient {
    constructor() {
        super(...arguments);
        this.entityPath = 'mappings';
    }
    getUpdatePayloadModel(mapping, _) {
        return new MappingSaveRequestModel(mapping);
    }
    getAllWithPages(projectId, mappingFields, pageFields) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/mappings/with-pages?` + this.getQueryString({ mappingFields, pageFields });
            const response = yield this.httpGet(url);
            const mappings = response.payload || [];
            if (!this.canAccessReferenceMapping()) {
                return mappings.filter((mapping) => !mapping.isReferenceMapping);
            }
            return mappings;
        });
    }
    getWithSearch(projectId, searchRequestModel) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/mappings?` + this.getQueryString(searchRequestModel);
            const response = yield this.httpGet(url);
            let mappings = response.payload || [];
            if (!this.canAccessReferenceMapping()) {
                if (Array.isArray(mappings)) {
                    mappings = mappings.filter((mapping) => !mapping.isReferenceMapping);
                }
                else if (mappings.items) {
                    mappings.items = mappings.items.filter((mapping) => !mapping.isReferenceMapping);
                }
            }
            return mappings;
        });
    }
    clone(projectId, mappingId, overrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let body = {};
            const url = `/v1/projects/${projectId}/mappings/${mappingId}/clone`;
            if (overrides) {
                body = overrides;
            }
            const response = yield this.httpPost(url, body);
            return response.payload;
        });
    }
    deepClone(projectId, mappingId, overrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let body = {};
            const url = `/v1/projects/${projectId}/mappings/${mappingId}/deep-clone`;
            if (overrides) {
                body = overrides;
            }
            const response = yield this.httpPost(url, body);
            return response.payload;
        });
    }
    process(projectId, mappingId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/mappings/${mappingId}/process`;
            const response = yield this.httpPut(url);
            return response.payload;
        });
    }
    getPages(projectId, mappingId, fields, ids, includeDeleted) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/mappings/${mappingId}/pages?` + this.getQueryString({ fields, ids, includeDeleted });
            const response = yield this.httpGet(url);
            return response.payload || [];
        });
    }
    getPageById(projectId, pageId, fields) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/pages/${pageId}?` + this.getQueryString({ fields });
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getPageByIdWithMappingFavorite(projectId, pageId, fields) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/pages/${pageId}?` + this.getQueryString({ fields, withMappingFavorite: true });
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getSuggestedPagesByUrl(projectId, requestUrl) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/pages/suggested-pages`;
            const response = yield this.httpPost(url, { url: requestUrl });
            return response.payload || [];
        });
    }
    getPagesByProject(projectId, fields, ids, includeDeleted) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/pages?` + this.getQueryString({ fields, ids, includeDeleted });
            const response = yield this.httpGet(url);
            return response.payload || [];
        });
    }
    getPagesWithSearch(projectId, searchRequestModel) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/pages?` + this.getQueryString(searchRequestModel);
            const response = yield this.httpGet(url);
            return response.payload || [];
        });
    }
    getByPage(projectId, pageId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/pages/${pageId}/mappings`;
            const response = yield this.httpGet(url);
            return response.payload || [];
        });
    }
    createPage(projectId, mappingId, page) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/${this.version}/projects/${projectId}${mappingId ? `/mappings/${mappingId}` : ''}/pages/`;
            const response = yield this.httpPost(url, page);
            return response.payload;
        });
    }
    pageFromUrl(projectId, url, options = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const target = business_constants_1.FovNodes.createFovFromUrl(url, options);
            return this.createPage(projectId, undefined, {
                name: url,
                categoryId: 42,
                type: 1,
                target: JSON.stringify(target),
            });
        });
    }
    createPages(projectId, mappingId, pages) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/mappings/${mappingId}/pages/many`;
            const response = yield this.httpPost(url, pages);
            return response.payload || [];
        });
    }
    getTopUrls(projectId, topUrlsModel, limit, page) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/top-urls?${this.getQueryString({ limit, page })}`;
            const response = yield this.httpPost(url, topUrlsModel);
            return response.payload || [];
        });
    }
    getPageCategories(search = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/page-categories?${this.getQueryString(search)}`;
            const response = yield this.httpGet(url);
            return response.payload || [];
        });
    }
    deletePageRelation(projectId, mappingId, pageId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/mappings/${mappingId}/pages/${pageId}`;
            const response = yield this.httpDelete(url);
            return response.payload;
        });
    }
    getExhaustiveness(projectId, mappingId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/mappings/${mappingId}/exhaustiveness`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getLinkedItems(projectId, mappingId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/mappings/${mappingId}/linkeditems`;
            const response = yield this.httpGet(url);
            return response.payload || {};
        });
    }
    getLinkedItemsV2(projectId, mappingId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v2/projects/${projectId}/mappings/${mappingId}/linkeditems`;
            const response = yield this.httpGet(url);
            return response.payload || [];
        });
    }
    deleteWithLinkedItems(projectId, mappingId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/mappings/${mappingId}/with-linkeditems`;
            const response = yield this.httpDelete(url);
            return response.payload;
        });
    }
    getPageLinkedItems(projectId, pageId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/pages/${pageId}/linkeditems`;
            const response = yield this.httpGet(url);
            return response.payload || [];
        });
    }
    deletePageLinkedItems(projectId, pageId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/pages/${pageId}/linkeditems`;
            const response = yield this.httpDelete(url);
            return response.payload;
        });
    }
    deletePageWithLinkedItems(projectId, mappingId, pageId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/mappings/${mappingId}/pages/${pageId}/with-linkeditems`;
            const response = yield this.httpDelete(url);
            return response.payload;
        });
    }
    exportMapping(projectId, mappingId, destinationProjectId, name) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/mappings/${mappingId}/export/${destinationProjectId}`;
            const response = name ? yield this.httpPost(url, { name }) : yield this.httpPost(url);
            return response.payload || [];
        });
    }
    includeTargetFilters(projectId, mappingId, pageId, filters) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/mappings/${mappingId}/pages/${pageId}/include-target-filters`;
            const response = yield this.httpPut(url, filters);
            return response.payload;
        });
    }
    excludeTargetFilters(projectId, mappingId, pageId, filters) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/mappings/${mappingId}/pages/${pageId}/exclude-target-filters`;
            const response = yield this.httpPut(url, filters);
            return response.payload;
        });
    }
    deleteTargetFilters(projectId, mappingId, pageId, filters) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/mappings/${mappingId}/pages/${pageId}/delete-target-filters`;
            const response = yield this.httpPut(url, filters);
            return response.payload;
        });
    }
    moveTargetFilters(projectId, mappingId, pageId, pageDest, filters) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/mappings/${mappingId}/pages/${pageId}/move-target-filters?${this.getQueryString(pageDest)}`;
            const response = yield this.httpPut(url, filters);
            return response.payload;
        });
    }
    getScreens(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { projectId, mappingId, filters } = request, queryParams = tslib_1.__rest(request, ["projectId", "mappingId", "filters"]);
            let url = `/v1/projects/${projectId}${mappingId ? `/mappings/${mappingId}` : ''}/screens?${this.getQueryString(queryParams)}`;
            if (filters) {
                url += `&filters=${encodeURIComponent(JSON.stringify(filters))}`;
            }
            const response = yield this.httpGet(url);
            return response.payload || [];
        });
    }
    getScreensV2(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { projectId } = request;
            const response = yield this.httpPost(`/v2/projects/${projectId}/screens`, request);
            return response.payload || [];
        });
    }
    getTargetOnExclusion(projectId, mappingId, pageId, filters) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/mappings/${mappingId}/pages/${pageId}/get-target-on-exclusion`;
            const response = yield this.httpPost(url, filters);
            return response.payload;
        });
    }
    getUrls(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { projectId, mappingId, filters } = request, queryParams = tslib_1.__rest(request, ["projectId", "mappingId", "filters"]);
            let url = `/v1/projects/${projectId}/mappings/${mappingId}/search-urls?${this.getQueryString(queryParams)}`;
            if (filters) {
                url += `&filters=${encodeURIComponent(JSON.stringify(filters))}`;
            }
            const response = yield this.httpGet(url);
            return response.payload || [];
        });
    }
    getUrlsV2(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { projectId, mappingId, filters } = request, queryParams = tslib_1.__rest(request, ["projectId", "mappingId", "filters"]);
            const url = `/v2/projects/${projectId}${mappingId ? `/mappings/${mappingId}` : ''}/search-urls?${this.getQueryString(queryParams)}`;
            let response;
            if (filters) {
                response = yield this.httpPost(url, { filters: JSON.stringify(filters) });
            }
            else {
                response = yield this.httpPost(url);
            }
            return response.payload || [];
        });
    }
    getViewsPerScreens(projectId, mappingId, aliasIds) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/mappings/${mappingId}/views-per-screen?${this.getQueryString({
                aliasIds,
            })}`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    updateColors(projectId, colors) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/pages/colors`;
            const response = yield this.httpPut(url, colors);
            return response.payload;
        });
    }
    createPageThumbnail(projectId, mappingId, pageId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.httpPost(`/v1/projects/${projectId}/mappings/${mappingId}/pages/${pageId}/thumbnail`);
        });
    }
    getReferenceMappingForProject(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.canAccessReferenceMapping()) {
                const url = `/v1/projects/${projectId}/mappings/reference-mapping`;
                const response = yield this.httpGet(url);
                return response.payload;
            }
            return null;
        });
    }
    getCategoriesForIndustry(industry) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/page-categories/industry/${industry}`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getAllReferenceMappingTemplates() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = '/v1/mappings/templates';
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getUrlClusters(projectId, request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/automapping/clusters`;
            const response = yield this.httpPost(url, request);
            return response.payload;
        });
    }
    getAutoMappingTerms(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/automapping/terms`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    triggerAutoMappingSampling(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/automapping/samples`;
            yield this.httpGet(url);
        });
    }
    getAutoMappingSamplingReadiness(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/automapping/sampling-readiness`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getTermKeyValues(projectId, request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { key, type } = request;
            const url = `/v1/projects/${projectId}/automapping/key-values?key=${key}&type=${type}`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    canAccessReferenceMapping() {
        var _a, _b, _c, _d, _e;
        const appContext = ((_a = global_object_1.default['__hls#context']) === null || _a === void 0 ? void 0 : _a.context) || {};
        return ((_b = appContext.user) === null || _b === void 0 ? void 0 : _b.type) === business_constants_1.UserType.Employee || ((_e = (_d = (_c = appContext.project) === null || _c === void 0 ? void 0 : _c.flags) === null || _d === void 0 ? void 0 : _d.referenceMapping) === null || _e === void 0 ? void 0 : _e.access);
    }
}
exports.MappingClient = MappingClient;
class MappingSaveRequestModel {
    constructor(mapping) {
        this.id = mapping.id;
        this.name = mapping.name;
        this.description = mapping.description;
        this.protected = mapping.protected;
        this.pages = mapping.pages;
        this.pageCount = mapping.pageCount;
        this.createdAt = mapping.createdAt;
        this.updatedAt = mapping.updatedAt;
        this.deletedAt = mapping.deletedAt;
        this.creatorId = mapping.creatorId;
        this.updaterId = mapping.updaterId;
        this.isFavorited = mapping.isFavorited;
        this.isReferenceMapping = mapping.isReferenceMapping;
        this.isReferenceMappingCreation = mapping.isReferenceMappingCreation;
        this.templateId = mapping.templateId;
        this.template = mapping.template;
    }
}
//# sourceMappingURL=mapping.client.js.map